module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA80lEQVR4AbxRSw6CUAykqAuP4IIAZzHhDp7QO5B4D3eEsPAGuvDznElo4it9sDDBzKTtvHnja8izxC+EUIFX8D6SfZWwZ8kgXODZHvWX1CBNkTyANYBvUMGems5RnQuKjEvDKkF2Fa5FzX1cji9SgrUl3AW4BRXsC+sb55KrtXBeHJ6hHUAFe2qet2VQDadHvmiHMwV7ap63ZpAa/6oM6pDgcYD+BBXsqXnejkENnEeHJ2g3UMGemudtchHpRaSzxG3++wtVwX6wvnHu+SI12rqBIKCCPTWdozoXFBmXhlWC7Cpci5r7uLkXfXDjYUgN0hRfAAAA//9CDldKAAAABklEQVQDAOm8d++BmnJwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/plus.png
// module id = lrNE
// module chunks = 2